import { createStitches } from '@stitches/react';

export const { styled, getCssText } = createStitches({});
